import * as React from 'react';
import { FC, Fragment, useEffect } from 'react';
import {
    DateField,
    downloadCSV,
    EmailField,
    Filter,
    List,
    SearchInput,
    TextField,
    usePermissions,
    useTranslate,
    TextInput,
    SelectField
} from 'react-admin';

import ListActions from '../components/actions';
import BulkDeleteButton from './actionsBulkDelete';
import BulkRecoverButton from './actionsBulkRecover';

import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import ListEmpty from '../components/listEmpty';
import { FilterProps, PermissionsType } from "../../types";
import ListPagination from "../components/ListPagination";
import CustomizableDatagrid from '../components/CustomizableDatagrid';
import { NumberInput } from 'react-admin';
import moment from 'moment';
import { useHistory } from 'react-router';

const exporter = async (items: any, fetchRelatedRecords: any, translate: any) => {
    var itemsForExport = items.map((item: any) => {
        const status = item.status == 0 ? translate("common.status_inactive") : translate("common.status_active");
        let gender = '';
        switch (item.gender) {
            case 0:
                gender = '不明'
                break;
            case 1:
                gender = '男性'
                break;
            case 2:
                gender = '女性'
                break;
            case 3:
                gender = '未選択'
                break;
        }

        return [item.id, item.firstname, item.lastname, item.firstname_kana, item.lastname_kana, item.email, item.post_code, item.pref, item.city, item.birthday, status, item.phone, item.address, gender, item.nickname, item.created ? moment(item.created).format('YYYY-MM-DD h:mm:ss a') : item.created, item.varified ? moment(item.varified).format('YYYY-MM-DD h:mm:ss a') : item.varified];
    });
    const csv = '\uFEFF' + convertToCSV({
        data: itemsForExport,
        encoding: 'CP932',
        fields: ["ID", "名", "姓", "メイ", "セイ", 'メールアドレス', '郵便番号', '都道府県', '市区町村', "生年月日", 'ステータス', '電話番号', '住所', "性別", 'ニックネーム', 'メールアドレス確認日', 'メールアドレス登録日'],
    });
    downloadCSV(csv, 'User_No_Role');
};

const UserBulkActionButtons = (props: JSX.IntrinsicAttributes) => {
    const { permissions } = usePermissions();
    const role = permissions?.role;
    const permission = permissions?.list_permission as PermissionsType;
    return (
        <Fragment>
            {(role ==='client_admin' || role ==='admin') && (permission?.permission_approve === true || permission?.permission_all === true) && <BulkRecoverButton {...props} />}
            {(role ==='client_admin' || role ==='admin') && (permission?.permission_approve === true || permission?.permission_all === true) && <BulkDeleteButton {...props} />}
        </Fragment>
    )
};

const UserFilter: FC<Omit<FilterProps, 'children'>> = props => {
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <NumberInput source="id@_eq" label={translate('user_list.id')} alwaysOn />
            <SearchInput source="note,firstname,lastname,firstname_kana,lastname_kana,email,post_code,pref,city,address,phone,nickname" alwaysOn />
        </Filter>
    )
};

const UserList = (props: any) => {
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const role = permissions?.role;
    const permission = permissions?.list_permission as PermissionsType;
    let edit = (permission?.permission_create_edit == true || permission?.permission_all == true) ? 'edit': '';
    const history = useHistory();
    useEffect( () => {
        history.location.pathname = '/user_trash';
    },[props]);
    const STATUS = [
        { id: 0, name: translate("common.status_inactive") },
        { id: 1, name: translate("common.status_active") },
    ]
    const GENDER = [
        { id: 0, name: '不明' },
        { id: 1, name: '男性' },
        { id: 2, name: '女性' },
        { id: 3, name: '未選択' },

    ]
    if (role ===undefined) {
        return null;
    }
    return (
        <List
            {...props}
            filters={<UserFilter />}
            sort={{ field: 'id', order: 'DESC' }}
            perPage={25}
            filterDefaultValues={{ kuchikomi_user: true, is_soft_deleted: true  }}
            bulkActionButtons={<UserBulkActionButtons />}
            pagination={<ListPagination />}
            exporter={(items: any, fetchRelatedRecords: any) => exporter(items, fetchRelatedRecords, translate)}
            actions={<ListActions to='user' />}
            empty={<ListEmpty />}
            //filterDefaultValues={{ status: 1 }}
            title={translate('menu.user.user_list')}
        >
            <CustomizableDatagrid rowClick={edit}>
                <TextField source="id" label={translate('user_list.id')} />
                <TextField source="lastname" label={translate('user_list.lastname')} />
                <TextField source="firstname" label={translate('user_list.firstname')} />
                <TextField source="lastname_kana" label={translate('user_list.lastname_kana')} />
                <TextField source="firstname_kana" label={translate('user_list.firstname_kana')} />
                <EmailField source="email" label={translate('user_list.email')} />
                <TextField source="post_code" label={translate('user_list.post_code')} />
                <TextField source="pref" label={translate('user_list.pref')} />
                <TextField source="city" label={translate('user_list.city')} />
                <TextField source="birthday" label={translate('user_list.birthday')} />
                <SelectField source="status" choices={STATUS} label={translate('user_list.status')} />
                <TextField source="phone" label={translate('user_list.phone')} />
                <TextField source="address" label={translate('user_list.address')} />
                <SelectField source="gender" choices={GENDER} label={translate('user_list.gender')} />
                <TextField source="nickname" label={translate('user_list.nickname')} />
                <DateField source="created" label={translate('user_list.created_email')} showTime={true} locales="ja-JP" />
                <DateField source="varified" label={translate('user_list.varified')} showTime={true} locales="ja-JP" />
            </CustomizableDatagrid>
        </List>
    );
};

export default UserList;
